import axiosInstance from "./axiosInstance";

const axios = axiosInstance;

export const getCompanyList = (params) =>
  axios.get(`companySetup/list`, {
    params,
  });

export const getSelectFieldsName = () => axios.get(`companySetup/fields-name`);

export const getStatesByCountryList = (id) =>
  axios.get(`companySetup/state-name`, {
    params: { id },
  });

export const createCompanySetup = (params) =>
  axios.post(`companySetup/create-company`, params);

export const updateCompanySetup = (params) =>
  axios.post(`companySetup/update-company`, params);

export const getSecondaryMaster = (params) =>
  axios.post(`companySetup/get-secondary`, params);

export const getSecondaryMasterID = (params) =>
  axios.post(`companySetup/secondary-master-id`, params);

export const insertSecondaryMaster = (params) =>
  axios.post(`companySetup/secondary-master`, params);

export const updateSecondaryMaster = (params) =>
  axios.post(`companySetup/update-secondary-master`, params);

export const getSecondaryMasterHistory = (params) =>
  axios.post(`companySetup/get-secondary-master-history`, params);

export const getSecondaryMasterHeader = (params) =>
  axios.post(`companySetup/get-secondaryHeader`, params)

export const createEmployee = (params) =>
  axios.post(`employee/create-employee`, params, {
    headers:
      params instanceof FormData
        ? {
            "Content-Type": "multipart/form-data",
          }
        : {},
  });

export const updateEmployee = (params) =>
  axios.post(`employee/update-employee`, params);

export const getCompanySelectList = () => axios.get(`employee/company-name`);

export const getEmployeeList = (params) => axios.post(`employee/list`, params);

export const getEmployeeListByOu = (params) => axios.post(`dbgt/employes/list`, params);

export const deleteEmployee = (id) =>
  axios.delete(`employee/delete-employee`, {
    params: { id },
  });

export const userLogin = (params) => axios.post(`user/login`, params);

export const getEmployeeNumberSeries = (id) =>
  axios.get(`employee/employee-series`, {
    params: { id },
  });

export const getAssignmentsByModule = (params) =>
  axios.get(`employee/assignment-module`, {
    params,
  });

export const getReportingManager = (params) =>
  axios.get(`employee/manager-list`, {
    params: params,
  });

export const createAssignmentDetails = (params) =>
  axios.post(`employee/create-assignment`, params);

export const addAssignmentModule = (params) =>
  axios.post(`employee/add-module`, params);

export const updateAssignmentDetails = (params) =>
  axios.post(`employee/update-assignment`, params);

export const getAssignmentsByID = (params) =>
  axios.post(`employee/employee-assignment`, params);

export const createStatutory = (params) =>
  axios.post(`employee/create-statutory`, params);

export const getHrmsBusinessunitMaster = (params) =>
  axios.get(`employee/businessunit-master`, {
    params: params,
  });

export const getStatutoryList = (params) =>
  axios.post(`employee/statutory-list`, params);

export const updateStatutoryList = (params) =>
  axios.post(`employee/update-statutory`, params);

export const getBankList = (params) =>
  axios.get(`employee/get-bank`, {
    params,
  });

export const getPaymentListType = () => axios.get(`employee/payment-type`);

export const createCompensation = (params) =>
  axios.post(`employee/create-compensation`, params);

export const getBankBranchList = (params) =>
  axios.get(`employee/bank-Branch-list`, {
    params,
  });

export const insertBankMaster = (params) =>
  axios.post(`employee/create-bank-master`, params);

export const createBankDetails = (params) =>
  axios.post(`employee/create-bank-details`, params);

export const getBankDetailsByID = (params) =>
  axios.post(`employee/payment-details`, params);

export const getPayElements = (params) =>
  axios.post(`employee/pay-elements`, params);

export const getCompensationDetailsByID = (params) =>
  axios.post(`employee/compensation-details`, params);

export const deleteCompensation = (params) =>
  axios.post(`employee/delete-compensation`, params);

export const getAssignmentHistory = (params) =>
  axios.post(`employee/assignment-history`, params);

export const getDefaultTemplateName = (params) =>
  axios.post(`employee/default-templates`, params);

export const getDefaultTemplateByID = (id) =>
  axios.get(`employee/templates-ByID`, {
    params: { id },
  });

export const createFamilyDetails = (params) =>
  axios.post(`employee/create-family`, params);

export const getFamilyDetails = (params) =>
  axios.post(`employee/get-family`, params);

export const deleteFamilyDetails = (id) =>
  axios.delete(`employee/delete-family`, {
    params: { id },
  });

export const deleteContactInformation = (id) =>
  axios.delete(`employee/delete-contact`, {
    params: { id },
  });

export const createQualificationDetails = (params) =>
  axios.post(`employee/create-qualification`, params);

export const getQualificationDetails = (params) =>
  axios.post(`employee/get-qualification`, params);

export const deleteQualificationDetails = (id) =>
  axios.delete(`employee/delete-qualification`, {
    params: { id },
  });

export const templateCalculation = (params) =>
  axios.post(`employee/templates-calculation`, params);

export const getLeaveTypes = () => axios.get(`leaves/leave-type`);

export const getLeaveList = () => axios.get(`leaves/leave-list`);

export const createLeave = (params) =>
  axios.post(`leaves/create-leave`, params);

export const updateLeaveStatus = (params) =>
  axios.post(`leaves/update-leave-status`, params);

export const getLeaveSession = () => axios.get(`leaves/leave-session`);

export const getLeaveBalance = () => axios.get(`leaves/leave-balance`);

export const getLeaveBalanceByCode = (params) =>
  axios.post(`leaves/leave-balance-by-code`, params);

export const getToBeAuthorized = (params) =>
  axios.post(`leaves/leave-to-authorized`, params);

export const createShift = (params) => axios.post(`shift/create-shift`, params);

export const updateShift = (params) => axios.post(`shift/update-shift`, params);

export const getShiftList = (params) => axios.post(`shift/shift-list`, params);

export const deleteShift = (id) =>
  axios.delete(`shift/delete-shift`, {
    params: { id },
  });

export const getLatitudeLongititude = (id) =>
  axios.get(`attendance/get-location`, {
    params: { id },
  });

export const signInAttendance = (params) =>
  axios.post(`attendance/sign-in-attendance`, params);

export const getAttendanceSwipe = (id) =>
  axios.get(`attendance/view-attendance`, {
    params: { id },
  });

export const getViewAttendanceList = (params) =>
  axios.get(`attendance/view-attendance-list`, {
    params,
  });

export const getPayRollElements = (params) =>
  axios.post(`payroll/get-payroll-elements`, params);

export const createPayRollInputs = (params) =>
  axios.post(`payroll/create-payroll-inputs`, params);

export const processPayRoll = (params) =>
  axios.post(`payroll/process-payroll`, params);

export const getProcessPeriod = (params) =>
  axios.get(`payroll/get-process-period`, {
    params,
  });

export const getEmloyeeePayrollHoldandRelease = (params) =>
  axios.get(`payroll/get-employee-hold-release`, {
    params,
  });

export const getHRMSYTDReport = (params) =>
  axios.post(`payroll/get-ytd-report`, params);

export const getHRMSYTDYears = (params) =>
  axios.post(`payroll/get-ytd-report-year`, params);

export const getCurrentPayrollData = (params) =>
  axios.post(`payroll/current-payroll`, params);

export const getPreviewPayslip = (params) =>
  axios.post(`payroll/current-payslip`, params);

export const employeeByModulesProcessPayRolls = (params) =>
  axios.post(`payroll/employee-by-module`, params);

export const downloadSifFile = (params) =>
  axios.post(`payroll/download-SifFile`, params);

export const getSalaryStatement = (params) =>
  axios.post(`payroll/get-salary-statement`, params);

export const getEmployeeCostStatement = (params) =>
  axios.post(`payroll/get-employee-cost-statement`, params);

export const getPayRollHistory = (params) =>
  axios.post(`payroll/get-payroll-history`, params);

export const updateAttendence = (params) =>
  axios.post(`attendance/update-attendance`, params);

export const updateAttendenceStatus = (params) =>
  axios.post(`attendance/update-attendance-status`, params);

export const authorizationAttendance = (params) =>
  axios.get(`attendance/get-authorization-attendance`, {
    params,
  });

export const getCurrencyList = (id) =>
  axios.get(`employee/currency-list`, {
    params: { id },
  });

export const CreatePayElementMaster = (params) =>
  axios.post(`paymasters/pay-element`, params);

export const GetPayelementMasterList = (params) =>
  axios.get(`paymasters/pay-element-listview`, {
    params,
  });

export const CreatePayGroupsMaster = (params) =>
  axios.post(`paymasters/pay-groups`, params);

export const GetPayGroupMasterList = (params) =>
  axios.get(`paymasters/pay-group-listview`, {
    params,
  });

export const GetPayGroupCodeList = (params) =>
  axios.post(`paymasters/pay-Group-Code-List`, params);

export const GetPayElementCodeList = (params) =>
  axios.get(`paymasters/pay-Element-Code-List`, { params });

export const CreatePayGroupCreate = (params) =>
  axios.post(`paymasters/pay-group-code-Create`, params);

export const GetPayGroupCodeTableListView = (params) =>
  axios.get(`paymasters/pay-group-Payelement-Listview`, {
    params,
  });

export const getPayEmployee = (params) =>
  axios.get(`paymasters/pay-employeecode`, {
    params,
  });

export const PayGroupToEmployeeCreate = (params) =>
  axios.post(`paymasters/pay-group-create-pay-employee`, params);

export const PayGroupToEmployeeTableList = (params) =>
  axios.get(`paymasters/pay-employee-table-list`, {
    params,
  });

export const getBulkByPayGroupCode = (params) =>
  axios.get(`payroll/get-bulk-paygroupcode`, {
    params,
  });

export const createBulkByPayGroupCode = (params) =>
  axios.post(`payroll/create-bulk-paygroupcode`, params);

export const getPayRoleCalendar = () =>
  axios.get(`paymasters/pay-role-Calendar-list
`);

export const payPeriodsperview = (params) =>
  axios.post(`paymasters/proccess-period-generate-view`, params);

export const CreateProcessPeriod = (params) =>
  axios.post(`paymasters/proccess-period-create`, params);

export const proccessPeriodDetailsTable = (params) =>
  axios.get(`paymasters/process-period-Details-listview`, {
    params,
  });

export const createPayElementGrouping = (params) =>
  axios.post(`paymasters/pay-element-group-mapping`, params);

export const updatePayElementGrouping = (params) =>
  axios.post(`paymasters/update-pay-element-group-mapping`, params);

export const getPayElementGroupMappingList = (params) =>
  axios.get(`paymasters/pay-element-group-mapping-List`, {
    params,
  });

export const createPayrollCalendar = (params) =>
  axios.post(`paymasters/pay-roll-calendar-create`, params);

export const getPayrollCalendarTableListView = (params) =>
  axios.get(`paymasters/pay-roll-calendar-listview`, {
    params,
  });

export const downloadPayslip = (params) =>
  axios.post(`payroll/download-payslip`, params);

export const sendPayslipEmail = (params) =>
  axios.post(`payroll/email-payslip`, params);

export const checkEmailStatus = (params) =>
  axios.post(`payroll/get-email-status`, params);

export const updatePayGroup = (params) =>
  axios.post(`paymasters/update-pay-group-master`, params);

export const updatePayelement = (params) =>
  axios.post(`paymasters/update-pay-element-master`, params);

export const getClassification = () =>
  axios.get(`paymasters/pay-element-classification-list
`);

export const payCurrencyList = () =>
  axios.get(`paymasters/pay-group-currency
`);

export const updatePayGrouCodeToPayEmployee = (params) =>
  axios.post(`paymasters/update-pay-group-create-pay-employee`, params);

export const getCompanyNameList = (params) =>
  axios.post(`companySetup/company-list`, params);

export const getSponsorList = (params) =>
  axios.post(`companySetup/sponsor-list`, params);

export const updatePayGroupCode = (params) =>
  axios.post(`paymasters/pay-group-code-update`, params);

export const getPayRollManualEntry = (params) =>
  axios.post(`payroll/get-manual-entry`, params);

export const payRollLockScreen = (params) =>
  axios.post(`payroll/payroll-lock-screen`, params);

export const getHoldReleaseDetails = (params) =>
  axios.post(`payroll/get-hold-release`, params);

export const deleteManualEntryById = (params) =>
  axios.post(`payroll/delete-manual-entry`, params);

export const getHRMSMonthList = (params) =>
  axios.get(`payroll/get-month-period`, {
    params,
  });

export const getHRMSActionMaster = (params) =>
  axios.get(`payroll/get-action-hold-release`, {
    params,
  });

export const getSelectModuleByText = (params) =>
  axios.get(`employee/select-module`, {
    params,
  });

export const getCommunicationtype = (params) =>
  axios.get(`employee/select-communication-type`, {
    params,
  });

export const deleteStatutoryDetailRow = (id) =>
  axios.delete(`employee/delete-statutory`, {
    params: { id },
  });

export const getPayRollByPayGroupNo = (params) =>
  axios.get(`payroll/get-payroll-paygroupno`, {
    params,
  });

export const getSalaryRevision = (params) =>
  axios.post(`payroll/get-salary-revision`, params);

export const getPayrollEmployeeList = (params) =>
  axios.post(`payroll/get-payroll-EmployeeList`, params);

export const executeHoldReleasePayroll = (params) =>
  axios.post(`payroll/get-hold-release-payroll`, params);

export const getEmployeeSeparation = (params) =>
  axios.get(`employee/employee-separation`, {
    params,
  });

export const createHRMSEmployeeseparationDtl = (params) =>
  axios.post(`employee/create-employee-separation`, params);

export const getEmployeeseparation = (params) =>
  axios.get(`employee/employee-separation`, {
    params,
  });

export const getEmployeeseparationListView = (params) =>
  axios.get(`employee/get-separation-listview`, {
    params,
  });

export const employeeUpdateSeparationStatus = (params) =>
  axios.post(`employee/update-separation-status`, params);

export const getCustomReport = (params) =>
  axios.post(`payroll/get-custom-report`, params);

export const getPayrollBulkInputs = (params) =>
  axios.post(`payroll/get-bulk-payroll`, params);

export const finalSettlementDetails = (params) =>
  axios.get(`payroll/final-settlement-details`, {
    params,
  });

// Query Builder APIs
export const queryBuilderTables = (params) =>
  axios.get(`/qb/tables`, { params });
export const queryBuilderColumns = (params) =>
  axios.get(`/qb/columns`, {
    params,
  });
export const getQBReportUsers = () => axios.get(`/qb/users`);

export const queryBuilderSave = (params) => axios.post(`/qb/save`, params);

export const getQueryBuilderReport = (params) =>
  axios.get(`/qb/reports`, {
    params,
  });

export const getQBReportData = (params) =>
  axios.get(`/qb/Reportdata`, {
    params,
  });

export const getQBReportDataColumns = (params) =>
  axios.get(`/qb/ReportdataColumns`, {
    params,
  });

export const generatePivotReport = (params) =>
  axios.post(`/qb/GeneratePivotReport`, params);

export const getQBreportFields = (params) =>
  axios.get(`/qb/fields`, {
    params,
  });

export const queryBuilderEdit = (params) => axios.post(`/qb/edit`, params);

// export const API_ENDPOINTS = {
//   QB_TABLES: "/qb/tables",
//   QB_COLUMNS: "/qb/columns"
// };

// const qbTables = async () => {
//   const endpoint = `${API_ENDPOINTS.QB_TABLES}`;
//   const { data } = await axios.get(endpoint);
//   return data;
// };
// export const useQBTables = () =>
//   useQuery([API_ENDPOINTS.QB_TABLES], () => qbTables());

// const qbColumns = async (tableName) => {
//   const endpoint = `${API_ENDPOINTS.QB_COLUMNS}?tableName=${tableName}`;
//   const { data } = await axios.get(endpoint);
//   return data;
// };

// export const useQBColumns = (tableName) =>
//   useQuery([API_ENDPOINTS.QB_COLUMNS, tableName], () => qbColumns(tableName), {
//     enabled: !!tableName // Only run query if 'd' is truthy
//   });

export const quickSalaryStatement = (params) =>
  axios.post(`payroll/quick-payroll-finalstatement`, params);

export const getFinalSettlement = (params) =>
  axios.post(`payroll/final-settlememt`, params);

export const getEmployeeResignationReason = () =>
  axios.get(`employee/get-employee-resignation-reason`);

export const getPayrollSummary = (params) =>
  axios.post("payroll/payroll-summery-dashboard-list", params);

export const createTemplates = (params) =>
  axios.post(`employee/create-templates`, params);

export const getGroupOUList = () => axios.get(`employee/get-group-ou`);

export const insertHrmsPayment = (params) =>
  axios.post(`employee/create-payment-master`, params);

export const insertHrmsBranchMaster = (params) =>
  axios.post(`employee/create-branch-master`, params);

export const getMonthlyPayslip = (params) =>
  axios.post(`payroll/get-monthly-payslip`, params);

export const getOuByLocationID = (id) =>
  axios.get(`user/get-ou-By-LocationID`, {
    params: { id },
  });

export const saveCompanyAddSetup = (params) =>
  axios.post("companyAdditionalParam/save", params);

export const getCompanyAddParams = (params) =>
  axios.get("companyAdditionalParam/get", {
    params,
  });

export const getModuleScreenList = () =>
  axios.get(`workflowSetup/getModuleScreen
`);

export const saveWorkFlowSetup = (params) =>
  axios.post("workflowSetup/save", params);

export const getWorkflowData = (params) =>
  axios.get("workflowSetup/getWorkflowData", {
    params,
  });

export const updateWorkflowData = (params) =>
  axios.post("workflowSetup/updateWorkflow", {
    params,
  });

export const getUserListFromIam = (params) =>
  axios.post(`user/get-iam-user`, params);

export const createAirTicketEligibility = (params) =>
  axios.post(`ticket/create-air-ticket-Eligibility`, params);

export const updateAirTicketEligibility = (params) =>
  axios.post(`ticket/update-air-ticket-Eligibility`, params);

export const getAirTicketEligibility = (params) =>
  axios.get(`ticket/get-air-ticket-Eligibility`, {
    params,
  });

export const createAirTicketAmountBulk = (params) =>
  axios.post(`ticket/create-air-ticket-amount`, params);

export const updateAirTicketAmountBulk = (params) =>
  axios.post(`ticket/update-air-ticket-amount`, params);

export const getAirTicketAmountBulk = (params) =>
  axios.get(`ticket/get-air-ticket-amount`, {
    params,
  });
export const createRuleConfig = (params) =>
  axios.post(`employee/create-rule-config`, params);

export const getHrmsPeRuleConfig = (params) =>
  axios.get(`employee/get-rule-config-list-view`, {
    params,
  });

export const updateRuleConfig = (params) =>
  axios.post(`employee/update-rule-config`, params);

export const createTaxRateConfig = (params) =>
  axios.post(`employee/create-tax-slab`, params);

export const getTaxRateConfig = (params) =>
  axios.get(`employee/get-tax-slab-list-view`, {
    params,
  });

export const updateTaxRateConfig = (params) =>
  axios.post(`employee/update-tax-slab`, params);

export const getPaygroupsAndElements = (params) =>
  axios.get(`employee/get-paygroup-elements`, {
    params,
  });

export const createIamUserToEmployee = (params) =>
  axios.post(`user/iam-user-to-employee`, params);

export const getElementGroup = (params) =>
  axios.get(`employee/get-element-group`, {
    params,
  });

export const createEmployeeBulkUpload = (params) =>
  axios.post(`employee/insert-EmployeeBulkupload`, params);

export const createCompensationBulkUpload = (params) =>
  axios.post(`employee/insert-CompensationBulkupload`, params);

export const getCompensationFrequencyList = (params) =>
  axios.get(`employee/get-frequencyList`, {
    params,
  });

export const getBankAndBranchList = (params) =>
  axios.get(`employee/get-bankwithBranchList`, { params });

export const getActionList = () =>
  axios.get(`employee/get-actionList
`);
export const insertBuList = (params) =>
  axios.post(`companySetup/create-bu-list`, params);

export const getgroupList = (params) =>
  axios.get(`companySetup/get-group-list`, {
    params,
  });

export const getBuTableList = (params) =>
  axios.get(`companySetup/get-bu-list`, {
    params,
  });

export const getWorkFlowItems = (params) =>
  axios.get(`todo/get-work-flow-items`, {
    params,
  });

export const updateWorkflowStatus = (params) =>
  axios.post(`todo/update-work-flow-status`, params);

export const getUpdatedWorkFlowClosedStatus = (params) =>
  axios.get(`todo/get-updated-work-flow`, {
    params,
  });
export const getCompanyTableList = (params) =>
  axios.get(`companySetup/get-company-list`, {
    params,
  });


export const employeeAdditionalSave = (params) =>
  axios.post(`employeeAdditionalSection/save`, params);

export const getEmployeeAdditionalSection = (params) =>
  axios.get(`employeeAdditionalSection/getAll`, {
    params,
  });

export const updateEmployeeAdditionalSection = (params) =>
  axios.put(`employeeAdditionalSection/update`, {
    params,
  });
export const createContactInformation = (params) =>
  axios.post(`employee/create-contact-information`, params);

export const getContactInformation = (params) =>
  axios.get(`employee/get-contact-information`, {
    params,
  });

export const updateContactInformation = (params) =>
  axios.post(`employee/get-update-information`, params);

export const updateProfileImage = (params) => {
  return axios.post("employee/update-profile-image", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPayrolllockHistoryDetails = (params) =>
  axios.post(`payroll/get-payrolllock-history-details`, params);

export const deleteProfileImage = (params) =>
  axios.post(`employee/delete-profile-image`, params);

//Employee Additional Section apis for employee profile

export const EmpAddSectionDataSave = (params) =>
  axios.post(`employeeAdditionalSection/save-EmpAddSectionData`, params);

export const getEmpAdditionalSectionLabelDropdown = (params) =>
  axios.get(`employeeAdditionalSection/get-empLabel-dropdown`, {
    params,
  });

export const getEmpAddSectionData = (params) =>
  axios.get(`employeeAdditionalSection/get-EmpAddSectionData`, {
    params,
  });

export const updateEmpAddSectionData = (params) =>
  axios.put(`employeeAdditionalSection/update-EmpAddSectionData`, {
    params,
  });

export const getPaygroupExit = (params) =>
  axios.post(`payroll/get-paygroup-exit`, params);

export const EmpAddInfoMasterSave = (params) =>
  axios.post(`employeeAdditionalSection/save-EmpAddInfoMaster`, params);

export const getEmpAddInfoMasterFixedCode = (params) =>
  axios.get(`employeeAdditionalSection/get-EmpAddInfoMasterFixedCode`, {
    params,
  });
export const getAnomalyReport = (params) =>
  axios.post(`payroll/get-anomaly-report`, params);

export const getCompensationEmployeeList = (params) =>
  axios.post(`employee/CompEmp-list`, params);

// Cost Employee Setup Sunil//

export const createEmployeeCostCenter = (params) =>
  axios.post(`payroll/employee-cost-center`, params);

export const getEmployeeCostCentre = (params) =>
  axios.post(`payroll/get-cost-center`, params);

export const updateEmployeeCostCenter = (params) =>
  axios.post(`payroll/update-cost-center`, params);

export const deleteEmployeeCostCenter = (params) =>
  axios.post(`payroll/employee-cost-delete`, params);

export const getPayrollEmployee = (params) =>
  axios.post(`payroll/get-payroll-Employee`, params);

export const anomalySelectList = (params) =>
  axios.post(`payroll/anomaly-select`, params);

export const getEmployeesCurrencyList = (params) =>
  axios.post(`employee/get-employee-currency`, params);

export const verifyOtp = (params) => axios.post(`user/verify-otp`, params);

export const updatePassword = (params) =>
  axios.post(`user/update-password`, params);

export const userLoginAudit = () => axios.get(`user/user-login-activity`);

//emailPayslip//

export const sendEmailPayslip = (params) =>
  axios.post(`email/send-payslip`, params, { skipEncryption: true });

export const uploadHrmsLogos = (params) =>
  axios.post(`companySetup/upload-logo`, params);

// Darwin box apis
export const getDarwinBoxEmployeeData = (params) =>
  axios.post(`dbgt/getpostEmploye`, params);

export const getDarwinBoxCtcData = (params) =>
  axios.post(`dbgt/add-ctc-details`, params);

export const getDarwinBoxLeavetype = () => axios.get(`dbgt/leave/type`);

export const getDarwinBoxLeaveBalance = (params) => axios.post(`dbgt/getleave-balance`, params);

export const getDarwinBoxLeaveEncashment = (params) => axios.post(`dbgt/getleave-encashment`, params);

export const getDarwinBoxAccountingSection = (params) => axios.post(`dbgt/employee-accounts`, params);

export const getDarwinBoxLeaveIntergration = (params) => axios.post(`dbgt/getleave`, params);

export const getDarwinBoxAttendanceIntergration = (params) => axios.post(`dbgt/getattendance`, params);


// YTD Report Api Added
export const getYTDReportModuleGet = (params) =>
  axios.get(`employee/YTDReportModuleGet`, {
    params,
  });

export const getHRMSAssignmentsByModuleName = (params) =>
  axios.get(`employee/getAssignmentsByModuleName`, {
    params,
  });

// JV Configurator Api Added
export const insertHrsmJVPayElementDetails = (params) =>
  axios.post(`payroll/insert-hrms-jv-payelement`, params);

export const updateHrsmJVPayElementDetails = (params) =>
  axios.post(`payroll/update-hrms-jv-payelement`, params);

export const getHRSMJVPayElementDetails = (params) =>
  axios.post(`payroll/get-hrms-jv-payelement`, {
    params,
  });

export const getHRMSPayElementGroupingDetail = (params) =>
  axios.post(`payroll/get-payelement-grouping-detail`, {
    params,
  });

export const ssoLogin = (id) => axios.post(`user/sso-login`, {id});

export const getHrsmPayrollDashboard = (params) =>
  axios.post(`payroll/get-payRoll-dashboard`, params);

export const protectPayslipPdf = (payload) => {
    return axiosInstance.post(
      "payroll/protect-payslip-pdf",
      payload,
      {
        skipEncryption: true, // ✅ IMPORTANT
      }
    );
};

export const profileAttachmentToDrawinBox = (payload) => {
    return axiosInstance.post(
      "payroll/profileAttachment-to-darwinbox",
      payload,
      {
        skipEncryption: true, // ✅ IMPORTANT
      }
    );
};

export const updateHRMSPaySlipReleaseStatus = (params) =>
  axios.post(`payroll/payslip-release-status`, params);
// helpdesk APIs

export const createIssue = (formData) =>
  axios.post("helpdesk/create-issue", formData);

export const getAllTicketList = (params) => 
  axios.get(`helpdesk/getAll-Issue-Ticket`, {
    params
  });

export const getTicketById = (params) =>
  axios.get(`helpdesk/get-Issue-Ticket-by-id`, {
    params
  });

export const getHistoryList = (params) =>
  axios.get(`helpdesk/get-Issue-History-by-id`, {
    params
  });

export const getSingleTicketView = (params) =>
  axios.get(`helpdesk/get-Single-Ticket-View`, {
    params
  });

export const getIssueType = () => axios.get(`helpdesk/get-Issue-Type`);

export const getPriorityLevels = () => axios.get(`helpdesk/get-Priority-Levels`);

export const getProjects = () => axios.get(`helpdesk/get-Projects`);

export const updateTicketStatus = (params) =>
  axios.post(`helpdesk/update-ticket-status`, params);

export const getAllStatuses = () => axios.get(`helpdesk/get-All-Statuses`);

export const getAssignedToUsers = () => axios.get(`helpdesk/get-Assigned-To-Users`);

export const getAssignedFromUsers = () => axios.get(`helpdesk/get-Assigned-From-Users`);

export const getCoreHRDashboard = (params) => {
  return axios.post("/employee/core-hr-dashboard", params);
};

export const getHRMSPaygroupCodeexlconsult = (params) =>
  axios.post(`paymasters/pay-Group-Code-exlconsult`, params);

export const payrollDashboardPaygroupWise = (params) =>
  axios.post(`payroll/payroll-dashboard-paygroup-wise`, params);

export const getEmployeeWorkFlowData = (params) =>
  axios.post(`employee/employee-workflow`, params);

export const getEmployeeWorkFlowHistory = (params) =>
  axios.post(`employee/employee-workflow-history`, params);

export const getHRMSPaygroupSecMaster = (params) =>
  axios.post(`paymasters/pay-Group-Sec-Master`, params);

export const getHelpdeskDashboardData = (params) =>
  axios.get(`helpdesk/get-Helpdesk-Dashboard-Data`, {
    params
  });

export const getAnomalyFilterpayelementcodeRemarks = (params) =>
  axios.post(`payroll/get-anomaly-filter-payelementcode-remarks`, params);

export const editIssue = (formData) =>
  axios.post("helpdesk/edit-issue", formData);

export const getHelpdeskCategory = () =>
  axios.get("helpdesk/get-Helpdesk-Category");

export const createConversation = (params) =>
  axios.post("helpdesk/create-conversation", params);

export const getConversationList = (params) =>
  axios.post("helpdesk/get-conversation-list", params);

//Statutory Report APIs

export const getStatutoryReports = (params) =>
  axios.post("payroll/get-statutory-reports", params);

export const getStatutoryReportDetails = (params) =>
  axios.post("payroll/get-statutory-report-details", params);

export const getGratuityReport = (params) =>
  axios.post("payroll/get-gratuity-report", params);

// JV  APIs

export const GetHRMSpayelemtCodeByPaygroup = (params) =>
  axios.post("payroll/get-hrmspayelement-code-report", params);

export const GetEmployeesByPaygroup = (params) =>
  axios.post("payroll/get-employees-by-paygroup", params);

export const getHRMSCompanyCodeByPaygroup = (params) =>
  axios.post("payroll/get-company-code-by-paygroup", params);

export const getJVReport = (params) =>
  axios.post("payroll/get-jv-report", params);

export const createAdditionalCompensation = (params) =>
  axios.post(`employee/create-additional-compensation`, params);

export const getAdditionalCompensationDetailsByID = (params) =>
  axios.post(`employee/additional-compensation-details`, params);

export const hrmsdeleteregpayrolldata = (params) =>
  axios.post(`payroll/hrms-delete-reg-payroll-data`, params);

export const GetHRMSEmployeePaygroupByPeriod = (params) =>
  axios.post(`payroll/hrms-get-employee-paygroup-by-period`, params);

// Report Module Api

export const getHRMSReportMaster = (params) =>
  axios.post(`report/get-hrms-report-master`, params);

export const insertAndUpdateHRMSReportMaster = (params) =>
  axios.post(`report/insert-and-update-hrms-report-master`, params);

export const getHRMSReportMasterReportCode = (params) =>
  axios.post(`report/get-hrms-report-master-report-codes`, params);

export const getHRMSCompanyModules = (params) =>
  axios.post(`report/get-hrms-company-modules`, params)

export const getIAMRoles = (params) =>
  axios.post(`report/get-iam-roles`, params)

export const getHRMSReportAccess = (params) =>
  axios.post(`report/get-HRMS-report-access`, params)

export const insertAndUpdateHRMSReportAccess = (params) =>
  axios.post(`report/insertAndUpdate-HRMS-report-access`, params)

export const getHRMSReportModuleAndReportCode = (params) =>
  axios.post(`report/get-hrms-report-module-and-report-code`, params);

export const getHRMSModuleReportData = (params) =>
  axios.post(`report/get-hrms-module-report-data`, params);

export const getBusinessUnitMaster = (params) =>
  axios.post(`leaves/business-unit`, params);

export const getComplianceTasks = (params) =>
  axios.post(`payroll-compliance/get-compliance-tasks`, params);

export const addComplianceTask = (params) =>
  axios.post(`payroll-compliance/add-compliance-task`, params);

export const updateComplianceTask = (params) =>
  axios.post(`payroll-compliance/update-compliance-task`, params);

export const deleteComplianceTask = (params) =>
  axios.post(`payroll-compliance/delete-compliance-task`, params);

export const bulkAddComplianceTasks = (params) =>
  axios.post(`payroll-compliance/bulk-add-compliance-tasks`, params);

export const getUsersforActivity = (params) =>
  axios.post(`employee/get-users-for-activity`, params);

export const getPayrollDetailsDashboard = (params) =>
  axios.post(`payroll/get-payroll-details-dashboard`, params)